import { createSlice } from '@reduxjs/toolkit';

import { questionBankApi } from '../../../services/questionBankApi';

import { QuestionBankSectionResponse, QuestionBankState } from './types';

const initialState: QuestionBankState = {
  questionBankData: {},
  companyData: {
    data: [],
    message: '',
    status: ''
  },
  domainData: {
    data: [],
    message: '',
    status: ''
  },
  moduleData: {
    data: [],
    message: '',
    status: ''
  },
  questionTypeData: {
    data: [],
    message: '',
    status: ''
  },
  sectionsData: {} as QuestionBankSectionResponse
};

const questionBankSlice = createSlice({
  name: 'questionBank',
  initialState,
  reducers: {
    resetState: state => {
      state.questionBankData = {};
    }
  },
  extraReducers: builder => {
    builder.addMatcher(
      questionBankApi.endpoints.getQuestionBankQuestions.matchFulfilled,
      (state, action) => {
        state.questionBankData = action.payload;
      }
    );
    builder.addMatcher(
      questionBankApi.endpoints.getQuestionsByCompanyId.matchFulfilled,
      (state, action) => {
        state.questionBankData = action.payload;
      }
    );
    builder.addMatcher(
      questionBankApi.endpoints.getAllCompanies.matchFulfilled,
      (state, action) => {
        state.companyData = action.payload;
      }
    );
    builder.addMatcher(
      questionBankApi.endpoints.getAllDomains.matchFulfilled,
      (state, action) => {
        state.domainData = action.payload;
      }
    );
    builder.addMatcher(
      questionBankApi.endpoints.getAllModules.matchFulfilled,
      (state, action) => {
        state.moduleData = action.payload;
      }
    );
    builder.addMatcher(
      questionBankApi.endpoints.getAllQuestionTypes.matchFulfilled,
      (state, action) => {
        state.questionTypeData = action.payload;
      }
    );
    builder.addMatcher(
      questionBankApi.endpoints.getQuestionBankData.matchFulfilled,
      (state, action) => {
        state.sectionsData = action.payload;
      }
    );
  }
});

export default questionBankSlice.reducer;
